const statusCounters = {
  freeTrials: 'freeTrialsInPendingCount',
  orderInModeration: 'ordersInModerationCount',
  orderInProcessing: 'ordersInProcessingCount',
  orderWithNoActiveProviders: 'ordersWithNoActiveProvidersCount',
};

export default statusCounters;
